var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container"},[_c('div',{staticClass:"header-bar"},[_vm._t("left"),_vm._t("right")],2),_c('div',{staticClass:"fill-bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }